import { render, staticRenderFns } from "./ModalInfo.vue?vue&type=template&id=5a76c112&scoped=true"
import script from "./ModalInfo.vue?vue&type=script&lang=js"
export * from "./ModalInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalInfo.vue?vue&type=style&index=0&id=5a76c112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a76c112",
  null
  
)

export default component.exports